export const loadScript = (src: string, key: any): any => {
  new Promise(resolve => {
    if (window[key]) {
      resolve(window[key]);
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.onload = () => resolve(window[key]);
    document.body.appendChild(script);
  });
};
